export default store => store.bootstrap;
